// MacWindowControls.js
import React from 'react';
import '../styles/MacWindowControls.css';

function MacWindowControls() {
  return (
    <div className="mac-window-controls">
      <span className="mac-button mac-button-red"><span className="button-symbol">×</span></span>
      <span className="mac-button mac-button-yellow"><span className="button-symbol">–</span></span>
      <span className="mac-button mac-button-green"><span className="button-symbol-green">⌾</span></span>
      
    </div>
  );
}

export default MacWindowControls;
